// ============================================================
// SPORT PACK CONFIG — football / 38wins
// The platform reads all sport-specific branding, wording and
// season constants from this file. To re-skin the game for a
// different sport (e.g. NBA 82-0), replace the src/sport/
// folder — see src/sport/README.md for the full contract.
// ============================================================

const SPORT = {
  key: "football",

  // Identity / branding
  siteName: "38wins",
  domain: "38wins.io",
  logoFile: "38wins-logo-white.png", // lives in public/
  socialHandle: "@38WINS_IO",
  socials: [
    { label: "X", href: "https://x.com/38wins_io" },
    { label: "Instagram", href: "https://instagram.com/38wins_io" },
  ],

  // Season model
  seasonGames: 38,
  hasDraws: true, // NBA pack: false — draw displays collapse to W-L
  leagueSize: 20, // for the results-modal standings rank cap

  // Wording
  squadName: "XI", // what a complete lineup is called
  copy: {
    standardDesc: "Spin teams, lock in your XI, project your 38-game season.",
    rankedDesc: "Match against another player. Same teams, best squad wins.",
    dailyDesc: "One curated run per day. Same conditions for everyone.",
    resultsHeading: "Projected 38-game season",
    yourSquad: "Your XI",
    tagline: "Can you get 38 wins?",
  },
};

// "12-3-23" (with draws) or "59-23" (without)
export function recordString(season) {
  return SPORT.hasDraws
    ? `${season.wins}-${season.draws}-${season.losses}`
    : `${season.wins}-${season.losses}`;
}

export function shareText(season) {
  return `I just built a ${recordString(season)} ${SPORT.squadName} on ${SPORT.siteName}. ${SPORT.copy.tagline}`;
}

export default SPORT;
